import { render, staticRenderFns } from "./tilda_location_modal.vue?vue&type=template&id=4988680a&scoped=true&"
import script from "./tilda_location_modal.vue?vue&type=script&lang=js&"
export * from "./tilda_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4988680a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4988680a')) {
      api.createRecord('4988680a', component.options)
    } else {
      api.reload('4988680a', component.options)
    }
    module.hot.accept("./tilda_location_modal.vue?vue&type=template&id=4988680a&scoped=true&", function () {
      api.rerender('4988680a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/tilda/location/tilda_location_modal.vue"
export default component.exports